export const tipoCartaoOptions = [
  { id: 'PROVISORIO', nome: 'Provisório' },
  { id: 'DEFINITIVO', nome: 'Definitivo' },
];

export const statusCartaoOptions = [
  { id: 'ATIVO', nome: 'Ativo' },
  { id: 'CANCELADO', nome: 'Cancelado' },
  { id: 'BLOQUEADO', nome: 'Bloqueado' },
];

export const statusCartaoSearchOptions = [
  { value: 'ATIVO', label: 'Ativo' },
  { value: 'CANCELADO', label: 'Cancelado' },
  { value: 'BLOQUEADO', label: 'Bloqueado' },
];

export const tipoCartaoSearchOptions = [
  { value: 'PROVISORIO', label: 'Provisório' },
  { value: 'DEFINITIVO', label: 'Definitivo' },
];

export const getTipoCartaoLabel = (tipo) => {
  const found = tipoCartaoOptions.find((item) => item.id === tipo);
  return found ? found.nome : tipo || '—';
};

export const getStatusCartaoLabel = (status, ativo) => {
  if (status) {
    const found = statusCartaoOptions.find((item) => item.id === status);
    return found ? found.nome : status;
  }
  if (ativo === true) return 'Ativo';
  if (ativo === false) return 'Cancelado';
  return '—';
};

export const normalizeCartaoStatus = (cartao) => {
  if (cartao?.status) {
    return cartao.status;
  }
  if (cartao?.ativo === true) return 'ATIVO';
  if (cartao?.ativo === false) return 'CANCELADO';
  return null;
};
